import React from 'react';
import PropTypes from 'prop-types';

import ImageSliderName
  from 'components/dashboard/image-slider/ImageSliderName';
import InstagramSliderIsPublished
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderIsPublished';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './InstagramSliderItemHeaderContent.scss';

function InstagramSliderItemHeaderContent(props) {
  const { item, deleteImageSlider } = props;

  return (
    <div className="instagram-slider-header-content__component">
      <div className="title">
        <ImageSliderName
          itemId={item.id}
          name={item.name}
        />
      </div>
      <div className="delete">
        <CommonLinkDeleteButton
          linkItem={item}
          deleteFunction={deleteImageSlider}
        />
      </div>
      <div className="published-block">
        <InstagramSliderIsPublished item={item} />
      </div>
    </div>
  );
}

InstagramSliderItemHeaderContent.propTypes = {
  deleteImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default InstagramSliderItemHeaderContent;
